import { Avatar, Col, Icon, Row } from 'antd';
import * as React from 'react';
// import { FormattedMessage } from 'react-intl';
import './header.scss';
import AccountDropDown from './AccountDropDown';
import { BIGDATA_CONSTANT } from '../../../../common/constant';
import { useSelector } from '../../../../redux/store';
import { IState } from '../../../../redux/reducer';
import { User } from 'o2o_layout/lib/common/model';
import { UserDAL } from '../../../../dal/UserDAL';
import { DashboardProps } from '../ModernLayoutContainer';
import NotificationCmp from './NotificationCmp';
import { getPrimaryColor } from '../../../../common/helper';
import SockJsClient from '../../../../shares/SockJsClient';
import { DrawerQuickAccessComponent } from 'o2o_common_ui';
import PopoverWithMasking from './PopoverWithMasking';
import ApplicationDropDownV2 from 'o2o_layout/lib/common/ApplicationDropDownV2';

export interface IHeaderProps extends DashboardProps {
  width: number;
  renderBreadCrumbTop: any;
  renderTitle?: any;
}

const Header = (props: IHeaderProps) => {
  const refHeader = React.useRef<null>(null);
  const scrollUp = 'scroll-up';
  const scrollDown = 'scroll-down';
  let lastScroll = 0;

  const [visibleApplication, setVisibleApplication] = React.useState(false);
  const [visibleBookmark, setVisibleBookmark] = React.useState(false);
  const [visibleProfile, setVisibleProfile] = React.useState(false);

  const uiSetting = useSelector((state: IState) => state.uiSetting);

  const handleScroll = () => {
    if (refHeader && null !== refHeader.current) {
      const currentScroll = window.pageYOffset;
      if (currentScroll <= 0) {
        // @ts-ignore
        refHeader.current.classList.remove(scrollUp);
        return;
      }
      // @ts-ignore
      if (
        currentScroll > lastScroll &&
        // @ts-ignore
        !refHeader.current.classList.contains(scrollDown)
      ) {
        // down
        // @ts-ignore
        refHeader.current.classList.remove(scrollUp);
        // @ts-ignore
        refHeader.current.classList.add(scrollDown);
        // @ts-ignore
      } else if (
        currentScroll < lastScroll &&
        // @ts-ignore
        refHeader.current.classList.contains(scrollDown)
      ) {
        // up
        // @ts-ignore
        refHeader.current.classList.remove(scrollDown);
        // @ts-ignore
        refHeader.current.classList.add(scrollUp);
      }
      lastScroll = currentScroll;
    }
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, []);

  const user: User = useSelector((state: IState) => {
    return state.user;
  });

  const [noti, setNoti] = React.useState(undefined as any);

  const renderProfile = () => {
    return (
      <PopoverWithMasking
        placement='bottomLeft'
        trigger='click'
        visible={visibleProfile}
        onVisibleChange={(e: boolean) => setVisibleProfile(e)}
        content={
          <AccountDropDown
            {...props}
            user={user}
            accountUrl={BIGDATA_CONSTANT.url.apps.REACT_APP_ACCOUNT_APP as string}
            appUrl={process.env.REACT_APP_URL || ''}
          />
        }
      >
        <div style={{ position: 'relative', zIndex: 1030 }} onClick={() => setVisibleProfile(true)}>
          <Avatar size={40} icon='user' src={user.avatar} className='avatar1' />
          {user.totpEnabled ? (
            <span className='shield-avatar1'>
              <Icon
                component={() => {
                  return (
                    <svg width='1em' height='1em' viewBox='0 0 26 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M2.46141 5.76739C2 6.42478 2 8.37887 2 12.287V14.2117C2 21.1026 7.18095 24.4467 10.4316 25.8667C11.3133 26.2519 11.7542 26.4444 13 26.4444C14.2458 26.4444 14.6866 26.2519 15.5684 25.8667C18.819 24.4467 24 21.1026 24 14.2117V12.287C24 8.37887 24 6.42478 23.5386 5.76739C23.0772 5.10999 21.2398 4.48106 17.5651 3.22319L16.865 2.98354C14.9495 2.32785 13.9917 2 13 2C12.0083 2 11.0505 2.32785 9.135 2.98354L8.43489 3.22319C4.76017 4.48106 2.92282 5.10999 2.46141 5.76739ZM16.7393 12.3883C17.0765 12.0107 17.0437 11.4312 16.6661 11.094C16.2884 10.7568 15.709 10.7896 15.3718 11.1673L11.6905 15.2903L10.6282 14.1006C10.291 13.723 9.71157 13.6902 9.33393 14.0273C8.95629 14.3645 8.92349 14.944 9.26067 15.3216L11.0067 17.2772C11.1806 17.472 11.4293 17.5833 11.6905 17.5833C11.9516 17.5833 12.2003 17.472 12.3743 17.2772L16.7393 12.3883Z'
                        fill='currentColor'
                      ></path>
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M10.2861 13.8603C9.97313 13.7349 9.60249 13.7875 9.33393 14.0273C8.95629 14.3645 8.92349 14.944 9.26067 15.3216L11.0067 17.2772C11.1806 17.472 11.4293 17.5833 11.6905 17.5833C11.9516 17.5833 12.2003 17.472 12.3743 17.2772L16.7393 12.3883C17.0765 12.0107 17.0437 11.4312 16.6661 11.094C16.2884 10.7568 15.709 10.7896 15.3718 11.1673L11.6905 15.2903L10.6282 14.1006C10.5308 13.9915 10.4132 13.9112 10.2861 13.8603ZM0.230789 6.13539C0.314425 5.70138 0.467303 5.12716 0.824385 4.61841C1.18723 4.10144 1.684 3.76307 2.06826 3.53991C2.48117 3.30011 2.96802 3.07975 3.49041 2.86753C4.51901 2.44966 5.93966 1.96338 7.72136 1.35351L8.48728 1.09133C8.57688 1.06066 8.66529 1.03033 8.75261 1.00038C10.4093 0.432046 11.6687 0 13 0C14.3313 0 15.5907 0.432046 17.2474 1.00038C17.3347 1.03033 17.4231 1.06066 17.5127 1.09133L18.2787 1.35352C20.0604 1.96339 21.481 2.44967 22.5096 2.86753C23.032 3.07975 23.5188 3.30011 23.9317 3.53991C24.316 3.76307 24.8128 4.10144 25.1756 4.61841C25.5327 5.12716 25.6856 5.70138 25.7692 6.13539C25.8592 6.60236 25.9086 7.13406 25.9394 7.69943C26 8.81327 26 10.3225 26 12.2194V14.2117C26 22.3372 19.8349 26.1855 16.369 27.6994C16.3508 27.7074 16.3325 27.7154 16.314 27.7235C15.9143 27.8983 15.452 28.1005 14.9167 28.2375C14.328 28.3882 13.7286 28.4444 13 28.4444C12.2714 28.4444 11.672 28.3882 11.0833 28.2375C10.548 28.1005 10.0857 27.8983 9.68597 27.7235C9.66751 27.7154 9.64917 27.7074 9.63097 27.6994C6.16513 26.1855 2.03495e-07 22.3372 2.03495e-07 14.2117V12.2193C-8.37957e-06 10.3225 -1.52923e-05 8.81326 0.0606346 7.69943C0.0914199 7.13406 0.1408 6.60236 0.230789 6.13539ZM2 12.287C2 8.37887 2 6.42478 2.46141 5.76739C2.92282 5.10999 4.76017 4.48106 8.43489 3.22319L9.135 2.98354C11.0505 2.32785 12.0083 2 13 2C13.9917 2 14.9495 2.32785 16.865 2.98354L17.5651 3.22319C21.2398 4.48106 23.0772 5.10999 23.5386 5.76739C24 6.42478 24 8.37887 24 12.287V14.2117C24 21.1026 18.819 24.4467 15.5684 25.8667C14.6866 26.2519 14.2458 26.4444 13 26.4444C11.7542 26.4444 11.3133 26.2519 10.4316 25.8667C7.18095 24.4467 2 21.1026 2 14.2117V12.287Z'
                        fill='white'
                      ></path>
                    </svg>
                  );
                }}
              />
            </span>
          ) : (
            <span className='shield-avatar1'>
              <Icon
                component={() => {
                  return (
                    <svg width='1em' height='1em' viewBox='0 0 26 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <g clip-path='url(#clip0_128_1768)'>
                        <path
                          d='M14 18C14 18.5523 13.5523 19 13 19C12.4477 19 12 18.5523 12 18C12 17.4477 12.4477 17 13 17C13.5523 17 14 17.4477 14 18Z'
                          fill='white'
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M2 12.287C2 8.37887 2 6.42478 2.46141 5.76739C2.92282 5.10999 4.76017 4.48106 8.43489 3.22319L9.135 2.98354C11.0505 2.32785 12.0083 2 13 2C13.9917 2 14.9495 2.32785 16.865 2.98354L17.5651 3.22319C21.2398 4.48106 23.0772 5.10999 23.5386 5.76739C24 6.42478 24 8.37887 24 12.287V14.2117C24 21.1026 18.819 24.4467 15.5684 25.8667C14.6866 26.2519 14.2458 26.4444 13 26.4444C11.7542 26.4444 11.3133 26.2519 10.4316 25.8667C7.18095 24.4467 2 21.1026 2 14.2117V12.287ZM13 8.41667C13.5063 8.41667 13.9167 8.82707 13.9167 9.33333V14.2222C13.9167 14.7285 13.5063 15.1389 13 15.1389C12.4937 15.1389 12.0833 14.7285 12.0833 14.2222V9.33333C12.0833 8.82707 12.4937 8.41667 13 8.41667ZM13 19.1111C13.675 19.1111 14.2222 18.5639 14.2222 17.8889C14.2222 17.2139 13.675 16.6667 13 16.6667C12.325 16.6667 11.7778 17.2139 11.7778 17.8889C11.7778 18.5639 12.325 19.1111 13 19.1111Z'
                          fill='currentColor'
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M0.230789 6.13539C0.314425 5.70138 0.467303 5.12716 0.824385 4.61841C1.18723 4.10144 1.684 3.76307 2.06826 3.53991C2.48117 3.30011 2.96802 3.07975 3.49041 2.86753C4.51901 2.44966 5.93966 1.96338 7.72136 1.35351L8.48728 1.09133C8.57688 1.06066 8.66529 1.03033 8.75261 1.00038C10.4093 0.432046 11.6687 0 13 0C14.3313 0 15.5907 0.432046 17.2474 1.00038C17.3347 1.03033 17.4231 1.06066 17.5127 1.09133L16.865 2.98354C14.9495 2.32785 13.9917 2 13 2C12.0083 2 11.0505 2.32785 9.135 2.98354L8.43489 3.22319C4.76017 4.48106 2.92282 5.10999 2.46141 5.76739C2 6.42478 2 8.37886 2 12.287V14.2117C2 21.1026 7.18095 24.4467 10.4316 25.8667C11.3133 26.2519 11.7542 26.4444 13 26.4444C14.2458 26.4444 14.6866 26.2519 15.5684 25.8667C18.819 24.4467 24 21.1026 24 14.2117V12.287C24 8.37886 24 6.42478 23.5386 5.76739C23.0772 5.10999 21.2398 4.48106 17.5651 3.22319L16.865 2.98354L17.5127 1.09133L18.2786 1.35351C20.0603 1.96338 21.481 2.44966 22.5096 2.86753C23.032 3.07975 23.5188 3.30011 23.9317 3.53991C24.316 3.76307 24.8128 4.10144 25.1756 4.61841C25.5327 5.12716 25.6856 5.70138 25.7692 6.13539C25.8592 6.60236 25.9086 7.13406 25.9394 7.69943C26 8.81327 26 10.3225 26 12.2194V14.2117C26 22.3372 19.8349 26.1855 16.369 27.6994C16.3508 27.7074 16.3325 27.7154 16.314 27.7235C15.9143 27.8983 15.452 28.1005 14.9167 28.2375C14.328 28.3882 13.7286 28.4444 13 28.4444C12.2714 28.4444 11.672 28.3882 11.0833 28.2375C10.548 28.1005 10.0858 27.8983 9.686 27.7235C9.66753 27.7154 9.64918 27.7074 9.63097 27.6994C6.16513 26.1855 2.03493e-07 22.3372 2.03493e-07 14.2117V12.2193C-8.37957e-06 10.3225 -1.52886e-05 8.81326 0.0606346 7.69943C0.0914199 7.13406 0.1408 6.60236 0.230789 6.13539ZM13.747 14.7537C13.8538 14.6038 13.9167 14.4203 13.9167 14.2222V9.33333C13.9167 8.82707 13.5063 8.41667 13 8.41667C12.4937 8.41667 12.0833 8.82707 12.0833 9.33333V14.2222C12.0833 14.4203 12.1462 14.6038 12.253 14.7537C12.4192 14.9868 12.6919 15.1389 13 15.1389C13.3081 15.1389 13.5808 14.9868 13.747 14.7537ZM13.8519 17.0125C13.6318 16.7985 13.3313 16.6667 13 16.6667C12.6687 16.6667 12.3682 16.7985 12.1481 17.0125C11.9197 17.2346 11.7778 17.5452 11.7778 17.8889C11.7778 18.5639 12.325 19.1111 13 19.1111C13.675 19.1111 14.2222 18.5639 14.2222 17.8889C14.2222 17.5452 14.0803 17.2346 13.8519 17.0125ZM12.8154 17.1331C12.475 17.216 12.2222 17.5229 12.2222 17.8889C12.2222 18.3184 12.5704 18.6667 13 18.6667C13.4296 18.6667 13.7778 18.3184 13.7778 17.8889C13.7778 17.5229 13.525 17.216 13.1846 17.1331C13.1235 17.137 13.062 17.1389 13 17.1389C12.938 17.1389 12.8765 17.137 12.8154 17.1331Z'
                          fill='white'
                        />
                      </g>
                      <defs>
                        <clipPath id='clip0_128_1768'>
                          <rect width='26' height='29' fill='white' />
                        </clipPath>
                      </defs>
                    </svg>
                  );
                }}
              />
            </span>
          )}
        </div>
      </PopoverWithMasking>
    );
  };

  return (
    <div ref={refHeader}>
      <div
        className='pango-header'
        style={{
          position: 'fixed',
          zIndex: 1,
          width: `${props.width}px`,
          padding: '10px 35px',
        }}
      >
        <Row type='flex' gutter={[5, 5]} justify='space-between' align='middle'>
          <Col>{props.renderBreadCrumbTop()}</Col>
          <Col>
            <Row type='flex' gutter={[30, 5]} align='middle'>
              <Col>
                <div
                  onClick={() => {
                    setVisibleBookmark(true);
                  }}
                >
                  <Avatar
                    className='application'
                    icon={
                      <Icon
                        component={() => {
                          return (
                            <svg
                              width='1em'
                              height='1em'
                              viewBox='0 0 18 18'
                              fill='currentColor'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M6.64953 3.55166C7.72618 1.62025 8.2645 0.654541 9.06934 0.654541C9.87417 0.654541 10.4125 1.62025 11.4891 3.55166L11.7677 4.05134C12.0736 4.60019 12.2266 4.87461 12.4651 5.05568C12.7037 5.23674 13.0007 5.30396 13.5948 5.43838L14.1357 5.56077C16.2265 6.03381 17.2718 6.27034 17.5205 7.07011C17.7692 7.86989 17.0566 8.70325 15.6313 10.37L15.2625 10.8012C14.8575 11.2748 14.655 11.5116 14.5639 11.8046C14.4727 12.0976 14.5034 12.4135 14.5646 13.0455L14.6203 13.6208C14.8358 15.8446 14.9436 16.9564 14.2925 17.4507C13.6413 17.945 12.6626 17.4944 10.705 16.593L10.1986 16.3599C9.6423 16.1037 9.36416 15.9757 9.06934 15.9757C8.77451 15.9757 8.49637 16.1037 7.9401 16.3599L7.43366 16.593C5.47611 17.4944 4.49734 17.945 3.84621 17.4507C3.19509 16.9564 3.30283 15.8446 3.51832 13.6208L3.57407 13.0455C3.63531 12.4135 3.66593 12.0976 3.57482 11.8046C3.48371 11.5116 3.2812 11.2748 2.87617 10.8012L2.50742 10.37C1.0821 8.70325 0.369437 7.86989 0.618144 7.07011C0.866851 6.27034 1.91221 6.03381 4.00294 5.56077L4.54384 5.43838C5.13796 5.30396 5.43502 5.23674 5.67354 5.05568C5.91206 4.87461 6.06503 4.60019 6.37098 4.05134L6.64953 3.55166Z'
                                fill='currentColor'
                              />
                            </svg>
                          );
                        }}
                      />
                    }
                    shape='square'
                    style={{
                      background: visibleBookmark ? 'var(--primary-color)' : '#F0F2F5',
                      color: visibleBookmark ? '#fff' : 'var(--primary-color)',
                    }}
                  ></Avatar>
                </div>
              </Col>
              <Col>
                <div
                  onClick={() => {
                    setVisibleBookmark(true);
                  }}
                >
                  <Avatar
                    className='application'
                    icon={
                      <Icon
                        component={() => {
                          return (
                            <svg
                              width='1em'
                              height='1em'
                              viewBox='0 0 20 18'
                              fill='currentColor'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M0.611328 13.353V2.81132C0.611328 1.77267 1.44959 0.928913 2.48629 0.992628C3.40974 1.04938 4.50187 1.16157 5.34033 1.38282C6.33267 1.64468 7.51199 2.20242 8.44469 2.69561C8.7351 2.84917 9.04392 2.95569 9.35999 3.01574L9.35999 17.3717C9.07346 17.3085 8.79393 17.2066 8.52997 17.0659C7.58465 16.562 6.36317 15.9777 5.34033 15.7078C4.51114 15.489 3.43386 15.3769 2.51698 15.3195C1.46827 15.254 0.611328 14.4038 0.611328 13.353Z'
                                fill='currentColor'
                              />
                              <path
                                d='M10.7787 17.3717C11.0652 17.3085 11.3447 17.2066 11.6087 17.0659C12.554 16.562 13.7755 15.9777 14.7983 15.7078C15.6275 15.489 16.7048 15.3769 17.6217 15.3195C18.6704 15.254 19.5273 14.4038 19.5273 13.353V2.75021C19.5273 1.73589 18.727 0.903272 17.7133 0.938583C16.6459 0.975765 15.3156 1.08639 14.3254 1.38282C13.467 1.63982 12.4672 2.1553 11.6525 2.62684C11.3768 2.78639 11.0821 2.90358 10.7787 2.97788L10.7787 17.3717Z'
                                fill='currentColor'
                              />
                            </svg>
                          );
                        }}
                      />
                    }
                    shape='square'
                    style={{
                      background: visibleBookmark ? 'var(--primary-color)' : '#F0F2F5',
                      color: visibleBookmark ? '#fff' : 'var(--primary-color)',
                    }}
                  ></Avatar>
                </div>
              </Col>
              <Col>
                <NotificationCmp
                  viewAllText='View all'
                  urlAccount={`${process.env.REACT_APP_CON_APP}system/notifications`}
                  userDAL={UserDAL}
                  notifications={noti}
                  commontActionFromDAL={props.commonActionFromDAL}
                />
              </Col>
              <Col>
                <PopoverWithMasking
                  className='o2o-popover'
                  placement='bottomLeft'
                  content={
                    <ApplicationDropDownV2
                      activeApp='account'
                      env='staging'
                      uiSetting={uiSetting}
                      user={user}
                      applicationHrefs={{
                        'data-hub': process.env.REACT_APP_CDP_APP!,
                        automation: process.env.REACT_APP_DMA_APP!,
                        console: process.env.REACT_APP_CON_APP!,
                        account: process.env.REACT_APP_ACCOUNT_APP!,
                        activation: process.env.REACT_APP_ACT_CON_APP!,
                        'help-center': 'https://help.pangocdp.com/',
                        pconnext: process.env.REACT_APP_PCX_CONSOLE!,
                        'pconnext-vus': process.env.REACT_APP_PCX_VUS_CONSOLE!,
                        'social-crm': `${process.env.REACT_APP_SOCIAL_CRM_APP}?orgId=${user?.orgCtx?.orgId}`!,
                      }}
                    />
                  }
                  title=''
                  trigger='click'
                  visible={visibleApplication}
                  onVisibleChange={(e: boolean) => {
                    setVisibleApplication(e);
                  }}
                >
                  <div
                    onClick={() => {
                      setVisibleApplication(true);
                    }}
                  >
                    <Avatar
                      className='application'
                      icon={
                        <Icon
                          component={() => {
                            return (
                              <svg
                                width='1em'
                                height='1em'
                                viewBox='0 0 19 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M10.9404 11.6675C10.9404 11.1153 11.3881 10.6675 11.9404 10.6675H17.2223C17.7746 10.6675 18.2223 11.1153 18.2223 11.6675V16.9495C18.2223 17.5018 17.7746 17.9495 17.2223 17.9495H11.9404C11.3881 17.9495 10.9404 17.5018 10.9404 16.9495V11.6675Z'
                                  fill='currentColor'
                                />
                                <path
                                  d='M10.9404 2.47481C10.9404 1.92253 11.3881 1.47482 11.9404 1.47482H17.2223C17.7746 1.47482 18.2223 1.92253 18.2223 2.47482V7.7568C18.2223 8.30908 17.7746 8.7568 17.2223 8.7568H11.9404C11.3881 8.7568 10.9404 8.30908 10.9404 7.7568V2.47481Z'
                                  fill='currentColor'
                                />
                                <path
                                  d='M0.635054 5.7557C0.23794 5.37188 0.227164 4.73881 0.610985 4.34169L3.76503 1.07841C4.14885 0.681299 4.78192 0.670523 5.17903 1.05434L8.44231 4.20838C8.83943 4.59221 8.8502 5.22528 8.46638 5.62239L5.31234 8.88567C4.92852 9.28279 4.29545 9.29356 3.89833 8.90974L0.635054 5.7557Z'
                                  fill='currentColor'
                                />
                                <path
                                  d='M0.825729 11.6676C0.825729 11.1153 1.27344 10.6676 1.82573 10.6676H7.10771C7.66 10.6676 8.10771 11.1153 8.10771 11.6676V16.9496C8.10771 17.5018 7.66 17.9496 7.10771 17.9496H1.82573C1.27344 17.9496 0.825729 17.5018 0.825729 16.9496V11.6676Z'
                                  fill='currentColor'
                                />
                              </svg>
                            );
                          }}
                        />
                      }
                      shape='square'
                      style={{
                        background: visibleApplication ? 'var(--primary-color)' : '#F0F2F5',
                        color: visibleApplication ? '#fff' : 'var(--primary-color)',
                      }}
                    ></Avatar>
                  </div>
                </PopoverWithMasking>
              </Col>
              <Col>{renderProfile()}</Col>

              <DrawerQuickAccessComponent
                title='QUICK ACCESS'
                visible={visibleBookmark}
                onClose={() => {
                  setVisibleBookmark(false);
                }}
                commonActionFromDALV2={props.commonActionFromDALV2}
                application='CDP'
                api_prefix={BIGDATA_CONSTANT.url.account || ''}
                baseUrlCDP={process.env.REACT_APP_CDP_APP || ''}
                baseUrlCON={process.env.REACT_APP_CON_APP || ''}
                baseUrlDMA={process.env.REACT_APP_DMA_APP || ''}
                color={getPrimaryColor(props.uiSetting)}
              />
              {props.user ? (
                <SockJsClient
                  url={process.env.REACT_APP_SOCKET_URL}
                  topics={[
                    // '/topic/global/messages',
                    `/topic/orgs/${props.user.orgCtx ? props.user.orgCtx.orgId : ''}/messages`,
                    `/topic/users/${props.user.orgCtx ? props.user.orgCtx.orgId : ''}_${props.user.id}/messages`,
                    `/topic/users/${props.user.orgCtx ? props.user.orgCtx.orgId : ''}_${props.user.id}/messages/stats`,
                  ]}
                  onMessage={(msg: any, header: any) => {
                    if (
                      props.user &&
                      header ==
                      `/topic/users/${props.user.orgCtx ? props.user.orgCtx.orgId : ''}_${props.user.id
                      }/messages/stats`
                    ) {
                      setNoti(msg);
                    } else {
                      if (msg) {
                        //@ts-ignore
                        notification[msg.messageLevel || 'info']({
                          message: msg.title || 'Title',
                          description: msg.message,
                          duration: 4.5,
                        });
                      }
                    }
                  }}
                />
              ) : null}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Header;
